import React, { useEffect } from 'react';
import FixedIcon from './Icons/FixedIcon';

const FixedIconRoom = ({
  icon,
  notVisiblePosition,
  mobileFixedPosition,
  index,
  isMobile,
  linkToProduct,
  animateFrom,
  history,
  nameIcon,
  zoomOutHandler,
}) => {
  useEffect(() => {
    const properFixedPosition = isMobile
      ? mobileFixedPosition
      : notVisiblePosition;
    if (typeof document !== `undefined`) {
      const iconContainerFixed = document.getElementById(`iconFixed${index}`);
      iconContainerFixed.style.top = properFixedPosition.top;
      iconContainerFixed.style.left = properFixedPosition.left;
    }
  }, [nameIcon, index, isMobile, mobileFixedPosition, notVisiblePosition]);

  const commonProps = {
    index,
    icon,
    history,
    animateFrom,
    isMobile,
  };
  return (
    <>
      <FixedIcon
        {...commonProps}
        linkToProduct={linkToProduct}
        zoomOutHandler={zoomOutHandler}
      />
    </>
  );
};

export default FixedIconRoom;
